import React from 'react';

export const TOPICS_UNAVAILABLE_TEXT = 'Practice topics are currently unavailable.';
export const TOPICS_ERROR_TEXT = 'Practice topics could not be loaded. Please try again.';
export const TOPICS_LOADING_TEXT = 'Loading practice topics…';

const noteIcon = (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <path d="M4 5.5A2.5 2.5 0 016.5 3H19a1 1 0 011 1v14.5a1 1 0 01-1 1H6.5A2.5 2.5 0 014 17V5.5z" stroke="currentColor" strokeWidth="1.4" />
    <line x1="8" y1="8" x2="16" y2="8" stroke="currentColor" strokeWidth="1.4" />
    <line x1="8" y1="12" x2="14" y2="12" stroke="currentColor" strokeWidth="1.4" />
  </svg>
);

/**
 * The topic papers of one Practice Topics page (tier) in a workspace, or the note that
 * stands in for them. A function, not a component, so that null reaches PracticeTopicsPages
 * as "nothing here". `topicSections` is buildTopicPaperSections' result; `renderTable`
 * is the workspace's own table of papers. Returns null when this tier has nothing to
 * say: only the Beginnings page carries the unavailable, loading and error notes.
 *
 * Empty (status 'ready', no papers) and failed (status 'error') are different notes.
 */
export function topicPapersContent({ prefix, tier, topicSections = [], topicStatus = 'ready', renderTable }) {
  const count = (topicSections || []).reduce(
    (sum, sec) => sum + (sec.tiers || []).reduce((n, t) => n + (t.params?.length || 0), 0),
    0,
  );
  if (count === 0) {
    if (tier !== 'beginnings') return null;
    let text = TOPICS_UNAVAILABLE_TEXT;
    if (topicStatus === 'error') text = TOPICS_ERROR_TEXT;
    else if (topicStatus === 'loading') text = TOPICS_LOADING_TEXT;
    return (
      <div className={`${prefix}-empty`}>
        {noteIcon}
        <p>{text}</p>
      </div>
    );
  }
  const sections = (topicSections || [])
    .map((sec) => ({ ...sec, tiers: (sec.tiers || []).filter((t) => t.tier === tier) }))
    .filter((sec) => sec.tiers.length > 0);
  if (!sections.length) return null;
  return (
    <div className={`${prefix}-topics`}>
      {sections.map((sec) => (
        <div key={sec.section} className={`${prefix}-topic-section`}>
          <h2 className={`${prefix}-section-title`}>{sec.label}</h2>
          {sec.tiers.map((tierBlock) => (
            <div key={`${sec.section}-${tierBlock.tier}`} className={`${prefix}-topic-tier`}>
              {renderTable(tierBlock.params || [])}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

